import axios from 'axios';
import Cookies from "universal-cookie";


const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  config => {
    const csrfToken = new Cookies().get("csrftoken");
    if (csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken;
    }
    config.headers['Content-Type'] = "application/json"
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axiosInstance;

